// src/components/treinamentos/TreinamentoVideoPlayer.js
import React from "react";
import { Play, BookOpen, Clock, ShieldCheck, CheckCircle2 } from "lucide-react";

export default function TreinamentoVideoPlayer({ youtubeId, title, estimatedMinutes, code }) {
  if (youtubeId && youtubeId.trim() !== "") {
    return (
      <div className="w-full rounded-2xl overflow-hidden shadow-md border border-slate-200 bg-slate-950 mb-6">
        <div className="relative w-full" style={{ paddingBottom: "56.25%" /* 16:9 */ }}>
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube-nocookie.com/embed/${youtubeId}?rel=0&modestbranding=1`}
            title={title || "Vídeo de Treinamento Sempre Joias"}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className="px-4 py-2.5 bg-slate-900 flex items-center justify-between text-xs text-slate-300">
          <span className="flex items-center gap-1.5 font-medium">
            <Play size={14} className="text-red-500 fill-red-500" />
            {code} — {title}
          </span>
          <span className="text-slate-400 text-[11px] flex items-center gap-1">
            <Clock size={12} /> {estimatedMinutes} min sugeridos
          </span>
        </div>
      </div>
    );
  }

  // Fallback quando não há vídeo (Guia Operacional Escrito)
  return (
    <div className="w-full rounded-2xl p-5 bg-gradient-to-r from-slate-900 via-indigo-950 to-slate-900 text-white shadow-sm border border-indigo-900/40 mb-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3.5">
          <div className="w-11 h-11 rounded-xl bg-indigo-500/20 border border-indigo-400/30 flex items-center justify-center text-indigo-300 shrink-0">
            <BookOpen size={22} />
          </div>
          <div>
            <div className="flex items-center gap-2 flex-wrap mb-1">
              <span className="px-2 py-0.5 rounded-md bg-indigo-500/30 text-indigo-200 text-[10px] font-bold uppercase tracking-wider border border-indigo-400/20">
                Guia Operacional Escrito & POP
              </span>
              <span className="px-2 py-0.5 rounded-md bg-emerald-500/20 text-emerald-300 text-[10px] font-semibold flex items-center gap-1 border border-emerald-500/30">
                <ShieldCheck size={11} /> 100% Autossuficiente
              </span>
            </div>
            <h4 className="text-sm font-bold text-white leading-snug">
              Procedimento Estruturado para Leitura Rápida na Bancada
            </h4>
            <p className="text-xs text-slate-300 mt-0.5 max-w-2xl leading-relaxed">
              Consulte os passos numerados, pontos críticos de atenção e checklists diretamente abaixo sem necessidade de reproduzir vídeo.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 self-end sm:self-center shrink-0">
          <span className="px-3 py-1.5 rounded-xl bg-white/10 text-white text-xs font-semibold flex items-center gap-1.5 border border-white/10">
            <Clock size={13} className="text-indigo-300" />
            {estimatedMinutes} min de leitura
          </span>
        </div>
      </div>
    </div>
  );
}
